<template lang="pug">
div
  .pa-2.mx-1.my-10
    v-row.my-10(justify="center")
      h2 Where could an EV take you?
    v-row
      v-col(cols=12 lg=3)
        CarSelector(:carList="cars" v-model="selectedCar")
      v-col
        HorizontalTripCard(:trip="trip" fromLabel="Where are you driving from?" toLabel="Where are you driving to?")
    v-row(justify="center")
      v-col(cols=7, lg=3)
        v-row(justify="center")
          v-btn.primary(v-on:click="routePlanning", block) Plan My Route
        v-row.pa-4(justify="center")
          p What to know more?
        v-row(justify="center")
          v-btn.accent(v-on:click="drivingDetails", block) See Fuel Savings
        v-row(justify="center")
          v-btn.accent.my-3(v-on:click="sharedTrips", block) See EV Owner Stories

    v-row(align="center", justify="end")
      v-col(cols=3)
        v-spacer
        em(style="font-size: 0.8em;margin-left:5px;") Powered by
        v-img(src="https://powersell.appstack.me/logo.png", width=100)
</template>

<script>
import HorizontalTripCard from "../components/HorizontalTripCard";
import CarSelector from "../components/CarSelector";
import Vue from 'vue';
export default {
  components: { HorizontalTripCard, CarSelector },
  data() {
    return {
      selectedCar: null,
      trip: {
        id: 1,
        title: "My Trip",
        frequency: 1,
        frequencyUnit: "workday",
        viaAddresses: [],
        fromAddress: { Address: null },
        toAddress: { Address: null },
        path: [],
      },
    };
  },
  mounted() {
    if (this.$route.query.state) {
      let state = this.$route.query.state;
      let loadState = this.loadState;
      setTimeout(function () {
        loadState(state);
      }, 1000);
    }
        Vue.prototype.$Countly.q.push([
      "add_event",
      {
        key: "Route Planner Landing Page",
        segmentation: {
          dealer: this.$dealer.default_settings.name,
        },
      },
    ]);
  },
  methods: {
    drivingDetails() {
      this.$router.push("recommender/0");
    },
    routePlanning() {
      this.$trips.length = 0;
      this.$trips.push(this.trip);
      this.$router.push("planner");
    },
    regularTrips() {
      this.$router.push("recommender/1");
    },
    sharedTrips() {
      this.$router.push("road-trips");
    },
    dealerAdmin() {
      this.$router.push("dealer");
    },
  },
};
</script>

<style scoped>
.v-card > h2,
.subtitle {
  color: #1e88e5;
  font-weight: bold;
}
a {
  text-decoration: none;
}
.right {
  float: right;
}
.v-card p {
  text-align: center;
}
.v-card .v-image {
  transform: translate(-50%, 0);
  left: 50%;
  opacity: 0.6;
}
.icon-image {
  opacity: 0.5;
  float: right;
}
.white {
  filter: invert(1);
  mix-blend-mode: lighten;
}
</style>